import { c as _c } from "react-compiler-runtime";
/* hs-eslint ignored failing-rules */
/* eslint-disable react/prop-types */

import { is } from 'immutable';
// @ts-expect-error - Remove once type definitions are available
import { getType } from '../../../common-message-format/operators/commonMessageFormatGetters';
import { MESSAGE_ID_ATTR } from '../../../web/message-history/constants/constants';
// @ts-expect-error - Remove once type definitions are available
import { getMessageId } from '../../../message-history/operators/getMessageId';
import { memo } from 'react';

// Props shared across MessageHistoryItem, VirtualizedMessageItem, and VirtualizedMessageHistoryCore.
import { jsx as _jsx } from "react/jsx-runtime";
const shouldRerender = (prev, next) => {
  return !Object.keys(prev).some(key => {
    if (key === 'fileAttachments' || key === 'positionDescriptors' || key === 'senders') {
      return !is(prev[key], next[key]);
    }
    // @ts-expect-error Leaving exisitng logic in place while converting to TS to prevent as many runtime changes as possible. Issue to fix: https://github.com/HubSpotEngineering/context-and-collab-projects/issues/1654
    return prev[key] !== next[key];
  });
};
const MessageHistoryItem = /*#__PURE__*/memo(t0 => {
  const $ = _c(33);
  const {
    allowContactPromotions,
    fileAttachments,
    fileAttachmentsForThread,
    friendlyNames,
    indexedAsyncFileAttachments,
    hiddenBy,
    historyConfig,
    message,
    portalId,
    positionDescriptors,
    presentSenderLocators,
    senders,
    recipientsMap,
    visitorLastReadTimestamp,
    vid,
    visitorRecipients,
    threadId,
    ungatedForNewForkedComponent,
    ungatedForOmnichannelCallSummaryAiSkill,
    ungatedForUnifiedCallSummary,
    ungatedForSDPPublicBetaURR,
    isUngatedForExpandCollapse,
    isUngatedForRethinkAttachments,
    channelName,
    slots,
    isLastMessage,
    getChirpThreadHistoryMessageById
  } = t0;
  let t1;
  if ($[0] !== message) {
    t1 = getMessageId(message);
    $[0] = message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      [MESSAGE_ID_ATTR]: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const idAttr = t2;
  const type = getType(message);
  const Component = historyConfig[type];
  let t3;
  if ($[4] !== Component || $[5] !== allowContactPromotions || $[6] !== channelName || $[7] !== fileAttachments || $[8] !== fileAttachmentsForThread || $[9] !== friendlyNames || $[10] !== getChirpThreadHistoryMessageById || $[11] !== hiddenBy || $[12] !== idAttr || $[13] !== indexedAsyncFileAttachments || $[14] !== isLastMessage || $[15] !== isUngatedForExpandCollapse || $[16] !== isUngatedForRethinkAttachments || $[17] !== message || $[18] !== portalId || $[19] !== positionDescriptors || $[20] !== presentSenderLocators || $[21] !== recipientsMap || $[22] !== senders || $[23] !== slots || $[24] !== threadId || $[25] !== ungatedForNewForkedComponent || $[26] !== ungatedForOmnichannelCallSummaryAiSkill || $[27] !== ungatedForSDPPublicBetaURR || $[28] !== ungatedForUnifiedCallSummary || $[29] !== vid || $[30] !== visitorLastReadTimestamp || $[31] !== visitorRecipients) {
    t3 = Component ? /*#__PURE__*/_jsx("div", Object.assign({}, idAttr, {
      children: /*#__PURE__*/_jsx(Component, {
        allowContactPromotions: allowContactPromotions,
        channelName: channelName,
        fileAttachments: fileAttachments,
        fileAttachmentsForThread: fileAttachmentsForThread,
        friendlyNames: friendlyNames,
        hiddenBy: hiddenBy,
        indexedAsyncFileAttachments: indexedAsyncFileAttachments,
        message: message,
        portalId: portalId,
        positionDescriptors: positionDescriptors,
        senders: senders,
        recipientsMap: recipientsMap,
        presentSenderLocators: presentSenderLocators,
        visitorLastReadTimestamp: visitorLastReadTimestamp,
        vid: vid,
        visitorRecipients: visitorRecipients,
        threadId: threadId,
        ungatedForNewForkedComponent: ungatedForNewForkedComponent,
        ungatedForOmnichannelCallSummaryAiSkill: ungatedForOmnichannelCallSummaryAiSkill,
        ungatedForUnifiedCallSummary: ungatedForUnifiedCallSummary,
        ungatedForSDPPublicBetaURR: ungatedForSDPPublicBetaURR,
        isUngatedForExpandCollapse: isUngatedForExpandCollapse,
        isUngatedForRethinkAttachments: isUngatedForRethinkAttachments,
        slots: slots,
        isLastMessage: isLastMessage,
        getChirpThreadHistoryMessageById: getChirpThreadHistoryMessageById
      })
    })) : null;
    $[4] = Component;
    $[5] = allowContactPromotions;
    $[6] = channelName;
    $[7] = fileAttachments;
    $[8] = fileAttachmentsForThread;
    $[9] = friendlyNames;
    $[10] = getChirpThreadHistoryMessageById;
    $[11] = hiddenBy;
    $[12] = idAttr;
    $[13] = indexedAsyncFileAttachments;
    $[14] = isLastMessage;
    $[15] = isUngatedForExpandCollapse;
    $[16] = isUngatedForRethinkAttachments;
    $[17] = message;
    $[18] = portalId;
    $[19] = positionDescriptors;
    $[20] = presentSenderLocators;
    $[21] = recipientsMap;
    $[22] = senders;
    $[23] = slots;
    $[24] = threadId;
    $[25] = ungatedForNewForkedComponent;
    $[26] = ungatedForOmnichannelCallSummaryAiSkill;
    $[27] = ungatedForSDPPublicBetaURR;
    $[28] = ungatedForUnifiedCallSummary;
    $[29] = vid;
    $[30] = visitorLastReadTimestamp;
    $[31] = visitorRecipients;
    $[32] = t3;
  } else {
    t3 = $[32];
  }
  return t3;
}, shouldRerender);
MessageHistoryItem.displayName = 'MessageHistoryItem';
export default MessageHistoryItem;